// documentMode is only available on ie11
// we use it to disable worker for ie11
// Can we delete this ?
// https://docs.microsoft.com/en-us/internet-explorer/ie11-deploy-guide/deprecated-document-modes

import { GlobalWorkerOptions, PDFWorker } from 'pdfjs-dist';

// @ts-ignore
const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

// @ts-ignore
if (document.documentMode) {
  // @ts-ignore
  PDFWorker.prototype._initialize = () => {
    // @ts-ignore
    this._setupFakeWorker();
  };
}

GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const worker = new PDFWorker();
